﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class PermissionClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    search(text, maxResults) {
        return this.client.apiPermissionsSearchByTextByMaxGet(text, maxResults);
    }
}
exports.PermissionClient = PermissionClient;
//# sourceMappingURL=PermissionClient.js.map